import styled from 'styled-components'
import { ContainerSombra } from '../ContainerSombra'

export const tabelaDetalheControleComissaoPedidoStyles = {
  ContainerTabela: styled(ContainerSombra)`
    padding: 20px 24px;
    margin-top: 16px;
  `
}
